
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import { IErrorModel } from '@/models/errors.model';
  import { IOneStepLoginModel, ILoginPasswordResultModel } from '@/models/login.model';

  import accountService from '@/services/account.service';
  import recaptchaService from '@/services/recaptcha.service';
  import tokenService from '@/services/token.service';

  @Component({
    components: {
      Input
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class LoginOneStep extends Vue {
    data() {
      return {
        isLoginLoading: false,
        isFocused: false,
        isLabeled: false,
        errors: new Array<IErrorModel>(),
        hasConfirmedError: false,
        form: { } as IOneStepLoginModel
      }
    };

    created() {
      this.$data.form = {
          ClientId: this.$route.query.client_id,
          RedirectUrl: this.$route.query.redirectUrl,
          StudioName: this.$data.RCEnvironment.VUE_APP_REGISTER_STUDIO_NAME
        } as IOneStepLoginModel;
    }

    public logIn() {
      if (this.$data.isLoginLoading) {
        return;
      }

      this.$store.dispatch("updateIsLoading", true);
      this.$data.isLoginLoading = true;
      this.$data.errors = new Array<IErrorModel>();
      this.$data.hasConfirmedError = false;

      if (this.$data.RCEnvironment.VUE_APP_ENABLE_RECAPTCHA == true) {
        recaptchaService.getToken(this, "login").then(token => {
          this.$data.form.Token = token;

          setTimeout(() => {
            recaptchaService.verify(this, this.$data.form.Token)
              .then(response => {
                if (!response.Success) {
                  this.$data.isLoginLoading = false;
                  this.$data.errors = [{ Property: "", ErrorMessage: "An error occured. Please try again later." } as IErrorModel];
                  this.$store.dispatch("updateIsLoading", false);
                  return;
                }

                if (!response.IsValid) {
                  this.$data.isLoginLoading = false;
                  this.$data.errors = [{ Property: "", ErrorMessage: "You are not allowed to log in." } as IErrorModel];
                  this.$store.dispatch("updateIsLoading", false);
                  return;
                }

                this.logInUserRequest();
              });
          }, 300);
        }).catch(() => {
          this.$data.isLoginLoading = false;
        });
      } else {
        this.logInUserRequest();
      }
    }

    public getFilteredErrors(property: string = '') {
      if (property == '') {
        return (this.$data.errors as Array<IErrorModel>).filter(error => !["UsernameOrEmail", "Password"].includes(error.Property));
      } else {
        return (this.$data.errors as Array<IErrorModel>).filter(error => error.Property == property);
      }
    }

    logInUserRequest() {
      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "log/log-in";

      accountService.post<IOneStepLoginModel, ILoginPasswordResultModel>(this, url, this.$data.form)
        .then(response => {
          this.$store.dispatch("updateIsLoading", false);

          const now = new Date();
          this.$cookies.set("_g2g_identity_", response.Created, new Date(now.setDate(now.getDate() + 30)), undefined, undefined, undefined, "Strict");

          this.$data.isLoginLoading = false;

          tokenService.setToken(this, true, true, this.$cookies);
        })
        .catch(error => {
          const errors = error.data.ErrorMessages as Array<IErrorModel>;
          this.$data.isLoginLoading = false;

          errors.forEach(err => {
            if (err.ErrorMessage == "ERROR_USER_CONFIRMED") {
              err.Property = "Confirmed";
              this.$data.hasConfirmedError = true;
            }
            else if (err.ErrorMessage == "ERROR_USER_IP_BANNED") {
              err.ErrorMessage = "ERROR_USER_IP_BANNED_LOGIN";
              this.$data.errors.push(err);
            }
            else {
              this.$data.errors.push(err);
            }
          });

          this.$store.dispatch("updateIsLoading", false);
        });
    }

    public updateStringValue(parameterName: string, value: string) {
      this.$data.form[parameterName] = value;
    }
  }
